import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Spinner from './Spinner'
import 'bootstrap/dist/css/bootstrap.min.css'

const divoStyle = {
  padding: '0px',
}

const diviStyle = {
  padding: '0px',
  float: 'left',
  display: 'inline',
}

class Templ extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (this.props.employee.employee) {
      const empl = this.props.employee.employee
      const l = '/users/' + empl['id'] + '/cerere_incetare_contract'
      const lq = '/users/' + empl['id'] + '/adeverinta'
      const la = '/users/' + empl['id'] + '/act_aditional'
      return <div><h3>Templates</h3><br /><div className="col-sm-12" style={divoStyle}><div className="col-sm-12" style={divoStyle}><div className="col-sm-4" style={diviStyle}>Act aditional</div><div className="col-sm-6 offset-sm-2" style={diviStyle}><a href={la} className="btn btn-secondary">Generate</a></div></div><br /><br /><div className="col-sm-12" style={divoStyle}><div className="col-sm-4" style={diviStyle}>Cerere incetare contract</div><div className="col-sm-6 offset-sm-2" style={diviStyle}><a href={l} className="btn btn-secondary">Generate</a></div></div><br /><br /><div className="col-sm-12" style={divoStyle}><div className="col-sm-4" style={diviStyle}>Adeverinta</div><div className="col-sm-6 offset-sm-2" style={diviStyle}><a href={lq} className="btn btn-secondary">Generate</a></div></div></div></div>
    }
    return <div><Spinner></Spinner></div>
  }
}

Templ.propTypes = {
  employee: PropTypes.object.isRequired,
}

export default Templ
